import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.promise.all-settled.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getUhvLatestApi } from '@/api';


import { mapState, mapActions } from 'vuex';
import dayjs from 'dayjs';
// 特高壓欄位：[欄位, 中文名稱, 單位]，順序即顯示順序
var UHV_FIELDS = [['MVA', '視在功率', 'MVA'], ['Mvar', '無效功率', 'Mvar'], ['PF', '功率因數', ''], ['Freq', '頻率', 'Hz'], ['Vll_ab', '線電壓 ab', 'kV'], ['Vll_bc', '線電壓 bc', 'kV'], ['Vll_ca', '線電壓 ca', 'kV'], ['Vln_a', '相電壓 a', 'kV'], ['Vln_b', '相電壓 b', 'kV'], ['Vln_c', '相電壓 c', 'kV'], ['I_a', '電流 a', 'A'], ['I_b', '電流 b', 'A'], ['I_c', '電流 c', 'A'], ['I_n', '中性線電流', 'A'], ['MTR_temp', '變壓器溫度', '°C'], ['HV_winding_temp', '高壓側繞組溫度', '°C'], ['LV_winding_temp', '低壓側繞組溫度', '°C']];
var withUnit = function withUnit(value, unit) {
  return value === null || value === undefined ? '—' : "".concat(value).concat(unit ? ' ' + unit : '');
};
export default {
  name: 'OtherInformation',
  data: function data() {
    return {
      uhvList: [],
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryData'])), {}, {
    urlSiteName: function urlSiteName() {
      return this.$route.query.siteName;
    },
    uhvTime: function uhvTime() {
      var _this$uhvList$;
      var ts = (_this$uhvList$ = this.uhvList[0]) === null || _this$uhvList$ === void 0 ? void 0 : _this$uhvList$.timestamp;
      return ts ? dayjs(ts).format('YYYY-MM-DD HH:mm') : '';
    },
    uhvCards: function uhvCards() {
      return this.uhvList.map(function (meter) {
        return {
          title: meter.meter_id,
          headline: withUnit(meter.MW, 'MW'),
          rows: UHV_FIELDS.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 3),
              key = _ref2[0],
              label = _ref2[1],
              unit = _ref2[2];
            return {
              label: label,
              value: withUnit(meter[key], unit)
            };
          })
        };
      });
    },
    etcCards: function etcCards() {
      var _this = this;
      var site = this.factoryData.find(function (x) {
        return (x === null || x === void 0 ? void 0 : x.factoryName) === _this.urlSiteName;
      } // 用 factoryName 去比對，不用 displaySiteName，展示案場無此頁
      );
      if (!site) return [];
      var dataKeyList = ['HV-meter', 'MVCB-meter', 'LV-meter', 'Sepam S40', 'Shihlin SPM3'];
      // Multimeters01、ProtectionRelay01… 可能有多個
      var data = Object.entries(site.etc || {}).filter(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          key = _ref4[0];
        return dataKeyList.includes(key) || key.includes('Multimeters') || key.includes('ProtectionRelay');
      }).reduce(function (accu, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        return _objectSpread(_objectSpread({}, accu), {}, _defineProperty({}, key, value));
      }, {});

      // 有風速計 可能是單一數值 或 陣列 ex: 3.3 or [3.3,2.8,...]
      var anemometer = site.Anemometer;
      if (typeof anemometer === 'number') {
        data.Anemometer = {
          Anemometer: anemometer
        };
      } else if (Array.isArray(anemometer)) {
        data.Anemometer = anemometer.reduce(function (accu, curr, index) {
          accu['Anemometer' + (index + 1).toString().padStart(2, '0')] = curr;
          return accu;
        }, {});
      }
      return Object.entries(data).map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          title = _ref8[0],
          info = _ref8[1];
        return {
          title: title,
          rows: Object.entries(info).map(function (_ref9) {
            var _ref10 = _slicedToArray(_ref9, 2),
              label = _ref10[0],
              value = _ref10[1];
            return {
              label: label,
              value: withUnit(value, '')
            };
          })
        };
      });
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncLastSingleDoc'])), {}, {
    fetchUhv: function fetchUhv() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getUhvLatestApi(_this2.urlSiteName);
              case 3:
                res = _context.sent;
                _this2.uhvList = res.data.data || [];
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    // 一次更新全部電表：特高壓（BQ）＋ 其他設備（最新一筆 doc）
    refreshAll: function refreshAll() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var onlyMissing;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                onlyMissing = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                _this3.loading = true;
                _context2.next = 4;
                return Promise.allSettled([_this3.fetchUhv(), onlyMissing && _this3.factoryData.length ? null : _this3.asyncLastSingleDoc(_this3.urlSiteName)]);
              case 4:
                _this3.loading = false;
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }),
  created: function created() {
    this.refreshAll(true);
  }
};